<!-- 产品解决方案／群星金融N+1供应链金融产品 -->
<template>
  <div id="core">
    <header>
      <div class="cover">
        <h1>核心企业</h1>
        <section>
          <span :class="active === 'N+1' ? 'active' : ''" @click="active = 'N+1'">N+1解决方案</span>
          <span :class="active === '1+N' ? 'active' : ''" @click="active = '1+N'">1+N解决方案</span>
        </section>
        <footer v-if="active === 'N+1'">
          <div class="contant">
            <h2>如何延长付款账期</h2>
            <h3>群星金融可提供一款“N+1现金采购”的供应链金融解决方案，基于核心企业对应付账款的确认/付款承诺，资金方受让供应商对核心企业的应收账款，给供应商提供融资/现金结算；核心企业可以延长对供应商的付款账期，获得经营性现金流；也可以获取融资利差。</h3>
            <h5 @click="topage('download', 'download-core')">下载方案</h5>
          </div>
          <img src="/imgs/portal/case/n+1@2x.png" alt="img">
        </footer>
        <footer v-else-if="active === '1+N'">
          <div class="contant">
            <h2>如何提前收取经销商货款</h2>
            <h3>群星通过对核心企业的应收账款进行资产分析，并引入金融机构购买应收账款资产，核心企业可以在风险不变、现金流不变的前提下，拉长给经销商的赊销账期，从而解决经销商的资金压力，帮助核心企业扩大销售规模。</h3>
            <h5 @click="topage('download', 'download-core')">下载方案</h5>
          </div>
          <img src="/imgs/portal/case/1+n@2x.png" alt="img">
        </footer>
      </div>
    </header>
    <div class="advantage">
      <div class="cover">
        <h1>对比银行贷款或发行债券，群星金融方案的优势在于</h1>
        <div class="list">
          <div>
            <strong>01</strong>
            <span>获得经营性现金流<br>不增加公司有息负债</span>
          </div>
          <div>
            <strong>02</strong>
            <span>不占贷款和发债额度<br>为公司留更多借款空间</span>
          </div>
          <div>
            <strong>03</strong>
            <span>优化财务报表<br>提升供应链整体竞争力</span>
          </div>
          <div>
            <strong>04</strong>
            <span>融资稳定性更高<br>较不宜受市场波动的影响</span>
          </div>
        </div>
        <h2>同时，群星会提供基于方案的如下供应链金融服务</h2>
        <h3 @click="topage('service')">进一步了解</h3>
        <h5>
          <div>
            <img src="/imgs/portal/home/zijin_1@2x.png" alt="img" class="img-1">
            <span>资金方案</span>
          </div>
          <div>
            <img src="/imgs/portal/home/data_1@2x.png" alt="img" class="img-2">
            <span>数据分析</span>
          </div>
          <div>
            <img src="/imgs/portal/home/lianshu_1@2x.png" alt="img" class="img-3">
            <span>链属营销</span>
          </div>
          <div>
            <img src="/imgs/portal/home/line_1@2x.png" alt="img" class="img-4">
            <span>线上平台</span>
          </div>
        </h5>
      </div>
    </div>
    <div class="bank">
      <div class="cover">
        <div class="cover-line">
          <img src="/imgs/portal/case/bank1@2x.png" alt="img">
          <img src="/imgs/portal/case/bank2@2x.png" alt="img">
          <img src="/imgs/portal/case/bank3@2x.png" alt="img">
          <img src="/imgs/portal/case/bank4@2x.png" alt="img">
        </div>
        <div class="cover-line" id="anchor">
          <img src="/imgs/portal/case/bank5@2x.png" alt="img">
          <img src="/imgs/portal/case/bank6@2x.png" alt="img">
          <img src="/imgs/portal/case/bank7@2x.png" alt="img">
          <img src="/imgs/portal/case/bank8@2x.png" alt="img">
        </div>
      </div>
    </div>
    <div class="form">
      <div class="cover">
        <h1>这里有适合您的资金方案</h1>
        <h2>留下您的联系方式，我们的顾问将随时为您提供帮助</h2>
        <portal-form :from='"case-core"' :roleType='active'></portal-form>
        <h3>此类个人信息仅用于注册，合同和联系目的，绝不会与第三方共享。<br>有关我们的更多信息以及我们如何保护您的个人信息，请参阅我们的<a href='/pdf/tips.pdf' download="隐私声明">隐私声明</a>。</h3>
      </div>
    </div>
    <portal-footer :page='"download-core"' :roleType='active'></portal-footer>
  </div>
</template>

<script>
import Footer from '../Footer'
import ModelFormVue from '../ModelForm.vue'

export default {
  data () {
    return {
      active: 'N+1'
    }
  },
  created () {
    this.active = this.$route.query.type === 'n1' || !this.$route.query.type ? 'N+1' : '1+N'
  },
  mounted () {
    if (this.$route.query.type === 'form') {
      this.scrollToForm()
    }
  },
  components: {
    'portal-footer': Footer,
    'portal-form': ModelFormVue
  },
  methods: {
    topage (way, page) {
      this.$router.push({path: way, query: {page: page, roleType: this.active}})
    },
    // 页面定位到留资位置
    scrollToForm () {
      window.scrollTo(0, 1530)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "~@/assets/css/utils";
@import "../../css/theme-config";

#core{
  margin-top: 96px;
  background:#f2f2f2;
  .cover{
    width: 1000px;
    margin: 0 auto;
    .cover-line{
      margin: 30px auto;
      display: flex;
      justify-content: space-between;
    }
  }
  header{
    background: url(/imgs/portal/case/bg1_project@2x.png) center center no-repeat;
    background-size: cover;
    height: 612px;
    h1{
      font-family: PingFangSC-Regular;
      font-size: 24px;
      color: #FFFFFF;
      letter-spacing: 0.5px;
      line-height: 24px;
      margin: 0;
      font-weight: normal;
      padding: 24px 0 6px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    }
    section{
      width: 282px;
      overflow: hidden;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #FFFFFF;
      letter-spacing: 0.5px;
      text-align: center;
      line-height: 14px;
      margin: 40px auto 26px;
      span{
        display: block;
        float: left;
        width: 140px;
        box-sizing: border-box;
        padding: 14px 0;
        border: 1px solid rgba(255,255,255,0.50);
        cursor: pointer;
      }
      span:first-child{
        border-top-left-radius: 30px;
        border-bottom-left-radius: 30px;
      }
      span:last-child{
        border-top-right-radius: 30px;
        border-bottom-right-radius: 30px;
      }
      .active{
        background: #FFFFFF;
        color: #333333;
        border-color: #FFFFFF;
      }
    }
    footer{
      .contant{
        width: 440px;
        display: inline-block;
        margin-right: 90px;
        vertical-align: top;
        color: #FFFFFF;
        letter-spacing: 0.5px;
        line-height: 30px;
        padding-top: 64px;
        font-family: PingFangSC-Regular;
        h2{
          font-family: PingFangSC-Semibold;
          font-size: 30px;
          line-height: 30px;
          font-weight: normal;
          margin: 0;
        }
        h3{
          font-size: 16px;
          text-align: justify;
          line-height: 26px;
          font-weight: normal;
          margin: 20px 0;
        }
        h5{
          cursor: pointer;
          font-size: 18px;
          color: #66BBFF;
          letter-spacing: 0.38px;
          line-height: 18px;
          padding-right: 15px;
          background: url(/imgs/portal/case/enter1@2x.png) right center no-repeat;
          background-size: 5px 10px;
          width: 90px;
          font-weight: normal;
          margin: 0;
          box-sizing: border-box;
        }
      }
      img{
        width: 464px;
      }
    }
  }
  .advantage{
    padding: 60px 0 70px;
    background: #FFFFFF;
    h1{
      font-family: PingFangSC-Medium;
      font-size: 40px;
      color: #222222;
      letter-spacing: 1.25px;
      text-align: center;
      line-height: 40px;
      font-weight: normal;
      margin: 0;
    }
    .list{
      margin: 50px auto 70px;
      overflow: hidden;
      div{
        width: 260px;
        height: 260px;
        font-family: PingFangSC-Regular;
        font-size: 18px;
        color: #FFFFFF;
        letter-spacing: 0.43px;
        text-align: center;
        line-height: 28px;
        background: rgba($color: #1F5DEA, $alpha: 0.8);
        border-radius: 100%;
        box-sizing: border-box;
        padding: 60px 0 70px;
        float: left;
        margin-left: -20px;
        strong{
          opacity: 0.3;
          font-family: PingFangSC-Semibold;
          font-size: 60px;
          letter-spacing: 1.5px;
          display: block;
          line-height: 60px;
          margin-bottom: 14px;
        }
      }
      div:first-child{
        margin-left: 10px;
      }
    }
    h2{
      font-family: PingFangSC-Medium;
      font-size: 38px;
      color: #222222;
      letter-spacing: 1.19px;
      text-align: center;
      line-height: 38px;
      font-weight: normal;
      margin: 0;
    }
    h3{
      font-family: PingFangSC-Regular;
      font-size: 24px;
      color: #0070C9;
      letter-spacing: 0.5px;
      text-align: center;
      line-height: 24px;
      font-weight: normal;
      margin: 18px auto 52px;
      width: 150px;
      padding-right: 10px;
      background: url(/imgs/portal/home/enter3@2x.png) right center no-repeat;
      background-size: 7px 14px;
      box-sizing: border-box;
      cursor: pointer;
    }
    h5{
      margin: 0;
      font-weight: normal;
      font-family: PingFangSC-Medium;
      font-size: 21px;
      color: #333333;
      letter-spacing: 0.75px;
      text-align: center;
      line-height: 21px;
      overflow: hidden;
      div{
        width: 100px;
        float: left;
        margin-right: 200px;
        img{
          margin: 0 auto;
          margin-bottom: 8px;
          display: block;
          &.img-1{
            width: 66px;
          }
          &.img-2{
            width: 73px;
          }
          &.img-3{
            width: 92px;
          }
          &.img-4{
            width: 98px;
          }
        }
      }
      div:last-child{
        margin-right: 0;
      }
    }
  }
  .bank{
    background: #191919;
    padding: 6px 0;
    img{
      height: 30px;
    }
  }
  .form{
    background: #FFFFFF;
    padding: 56px 0 70px;
    h1{
      font-family: PingFangSC-Semibold;
      font-size: 36px;
      color: #111111;
      letter-spacing: 1px;
      text-align: center;
      line-height: 36px;
      font-weight: normal;
      margin: 0;
    }
    h2{
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #333333;
      letter-spacing: 0.5px;
      text-align: center;
      line-height: 16px;
      font-weight: normal;
      margin: 12px 0 0;
    }
    h3{
      margin: 12px 0 0;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #A8ACB9;
      letter-spacing: 0.18px;
      text-align: center;
      line-height: 18px;
      font-weight: normal;
      a{
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #1F5DEA;
        letter-spacing: 0.18px;
        text-align: center;
        line-height: 18px;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Core.vue?47a9d890